export enum EBadgeVariant {
    DEFAULT = 'default',
    SECONDARY = 'secondary',
    DESTRUCTIVE = 'destructive',
    OUTLINE = 'outline',
    SUCCESS = 'success',
}

export enum EBadgeSize {
    SM = 'sm',
    DEFAULT = 'default',
}